import { render } from "./People.vue?vue&type=template&id=3d9c0c69&scoped=true"
import script from "./People.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./People.vue?vue&type=script&charset=utf-8&lang=js"

import "./People.vue?vue&type=style&index=0&id=3d9c0c69&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9c0c69"]])

export default __exports__